import { useEffect, useState } from "react";
import {
  Alert,
  Container,
  Row,
  Col,
  Spinner,
  Badge
} from "react-bootstrap";
import { useAuth } from "../components/auth/AuthProvider";
import DocumentosAdminSection from "../components/documents/DocumentosAdminSection";
import {
  getAdminDocumentGroups
} from "../controllers/documents";

function DocumentosAdmin() {
  const { token, hasPermission } = useAuth();
  const isDocumentAdmin = hasPermission('documentos_admin');
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  useEffect(() => {
    document.title = 'FAMA - Administración de Documentos';
  }, []);

  useEffect(() => {
    if (!isDocumentAdmin) {
      setError('No tienes permiso para acceder a esta sección.');
      setLoading(false);
      return;
    }
    loadData();
  }, [isDocumentAdmin, token]);

  async function loadData() {
    setLoading(true);
    setError(null);
    try {
      const data = await getAdminDocumentGroups(token);
      setGroups(data);
    } catch (e) {
      setError('No se pudieron cargar los documentos. Inténtelo más tarde.');
    } finally {
      setLoading(false);
    }
  }

  function showSuccess(msg) {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(null), 4000);
  }

  if (!isDocumentAdmin) {
    return (
      <Container className="pt-5 pb-5">
        <Alert variant="danger">No tienes permiso para acceder a esta sección.</Alert>
      </Container>
    );
  }

  return (
    <Container className="pt-5 pb-5">
      <Row className="mb-4">
        <Col>
          <h1>Administración de Documentos</h1>
          <p className="text-muted">Gestiona los grupos de documentos y la biblioteca de recursos.</p>
        </Col>
        <Col md="auto" className="d-flex align-items-center">
          <Badge bg="dark">Modo Administrador</Badge>
        </Col>
      </Row>

      {loading && (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      )}

      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}

      {!loading && (
        <DocumentosAdminSection
          token={token}
          groups={groups}
          onReload={loadData}
          onError={setError}
          onSuccess={showSuccess}
        />
      )}
    </Container>
  );
}

export default DocumentosAdmin;
